import { render, staticRenderFns } from "./Act_my.vue?vue&type=template&id=7921340b"
import script from "./Act_my.vue?vue&type=script&lang=js"
export * from "./Act_my.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports